<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>Modifier DM</h3>
          </template>

          <template v-slot:right-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button"> <i class="arrow left"></i> Retour </a>
          </template>
        </TopTemplate>

        <div class="alert alert-success" role="alert" v-if="is_created">Le devoir a été modifié avec succès !</div>

        <div class="ajout-container">
          <form @submit.prevent="onSubmitUpdateDevoir" novalidate>
            <div class="row">
              <div class="col-md-3">
                <div class="ajout-container__simple">
                  <label>Niveau</label>
                  <v-select
                    v-model="devoir.selectedLevel"
                    :options="levels"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    @update:modelValue="ChangeLevel($event)"
                    class="form-control"
                    :class="v$.devoir.selectedLevel.$error ? 'is-invalid' : ''"
                  >
                    <template #no-options="{search, searching, loading}"> Aucun résultat </template>
                  </v-select>
                  <span class="invalid-feedback" v-if="v$.devoir.selectedLevel.$error">
                    {{ v$.devoir.selectedLevel.$errors[0].$message }}
                  </span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="ajout-container__multiple">
                  <label>Classe</label>
                  <v-select
                    v-model="devoir.class_id"
                    :options="classes"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="v$.devoir.class_id.$error ? 'is-invalid' : ''"
                  >
                    <template #no-options="{search, searching, loading}"> Aucun résultat </template>
                  </v-select>
                  <span class="invalid-feedback" v-if="v$.devoir.class_id.$error">
                    {{ v$.devoir.class_id.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="ajout-container__multiple">
                  <label>Matière</label>
                  <v-select
                    v-model="devoir.course_id"
                    :options="courses"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="v$.devoir.course_id.$error ? 'is-invalid' : ''"
                  >
                    <template #no-options="{search, searching, loading}"> Aucun résultat </template>
                  </v-select>
                  <span class="invalid-feedback" v-if="v$.devoir.course_id.$error">
                    {{ v$.devoir.course_id.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="ajout-container__multiple">
                  <label>Pour le</label>
                  <input id="due_date" v-model="devoir.due_date" class="form-control" type="date" :class="v$.devoir.due_date.$error ? 'is-invalid' : ''" />
                  <span class="invalid-feedback" v-if="v$.devoir.due_date.$error">
                    {{ v$.devoir.due_date.$errors[0].$message }}
                  </span>
                </div>
              </div>

              <div class="col-12">
                <div class="ajout-container__text">
                  <label>Text</label>
                  <textarea class="form-control" v-model="devoir.description" rows="5" :class="v$.devoir.description.$error ? 'is-invalid' : ''"></textarea>
                  <span class="invalid-feedback" v-if="v$.devoir.description.$error">
                    {{ v$.devoir.description.$errors[0].$message }}
                  </span>
                  <label class="message-textarea">{{ $t('info.sizeText') }}</label>
                </div>
              </div>
              <div class="col-12">
                <div class="simple-input-checkbox">
                  <label class="container-checkbox">
                    <input type="checkbox" v-model="devoir.is_arabic" :value="devoir.is_arabic" :id="'arabic'" />
                    <span class="checkmark"></span>
                  </label>
                  <label class="label" :for="'arabic'">c'est arabe</label>
                </div>
              </div>
              <div class="col-12 buttons">
                <div class="button-left">
                  <button type="button" @click="resetForm" class="btn button btn-primary" :disabled="loading">
                    <i class="icon-Add"></i>
                    Annuler
                  </button>
                </div>
                <div class="button-right d-flex">
                  <button type="submit" class="btn button btn-primary" :disabled="loading">
                    <i class="icon-Check"></i>
                    Soumettre
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import buttonElement from "../../components/buttons/Button.vue";
import HomeWorkService from "../../services/home-work.service";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {required, maxLength, helpers} from "@vuelidate/validators";
import moment from "moment";

export default {
  name: "AjoutDm",
  components: {
    TopTemplate,
    buttonElement,
    "v-select": vSelect,
  },
  data() {
    return {
      v$: useValidate(),
      devoirId: null,
      devoir: new Form({
        selectedLevel: null,
        class_id: null,
        course_id: null,
        due_date: null,
        description: "",
        is_arabic: false,
      }),
      loading: false,
      classes: [],
      courses: [],
      levels: [],
      params: {
        class_type_id: [],
      },
      requiredDescriptionLength: 300,
      is_created: false,
    };
  },
  validations() {
    return {
      devoir: {
        selectedLevel: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        class_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        course_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        due_date: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        description: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(this.requiredDescriptionLength),
        },
      },
    };
  },
  created() {
    this.devoirId = this.$route.params.id;
  },
  mounted() {
    this.FilterHomeWorks();
    this.getById();
  },
  methods: {
    FilterHomeWorks() {
      this.loading = true;
      HomeWorkService.getFilter({
        params: {
          type_id: this.params.class_type_id,
        },
      }).then(
        (response) => {
          this.classes = _.orderBy(response.data.classes, "name");
          this.courses = _.orderBy(response.data.courses, "name");
          this.levels = response.data.types;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    getById() {
      HomeWorkService.get(this.devoirId)
        .then((response) => {
          let data = response.data.data;
          this.devoir.description = data.description;
          this.devoir.due_date = moment(data.due_date).format("YYYY-MM-DD");
          this.devoir.class_id = data.class.id;
          this.devoir.course_id = data.course.id;
          this.devoir.selectedLevel = data.type.id;
          this.devoir.is_arabic = data.is_arabic;
        })
        .catch((error) => {});
    },
    ChangeLevel(e) {
      if (e != null) {
        this.params.class_type_id = [];
        this.params.class_type_id.push(e);
      } else {
        this.params.class_type_id = [];
      }
      this.class_id = null;
      this.FilterHomeWorks();
    },
    onSubmitUpdateDevoir() {
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        const data = {
          class_type_id: this.devoir.selectedLevel,
          class_id: this.devoir.class_id,
          course_id: this.devoir.course_id,
          due_date: this.devoir.due_date,
          description: this.devoir.description,
          is_arabic: this.devoir.is_arabic,
        };
        HomeWorkService.update(this.devoirId, data).then(
          (response) => {
            this.is_created = true;
            this.loading = false;
            this.scrollToTop();
          },
          (error) => {
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          }
        );
      } else {
        this.is_created = false;
        this.loading = false;
        this.scrollToTop();
      }
    },
    resetForm() {
      this.devoir.selectedLevel = null;
      this.devoir.class_id = null;
      this.devoir.course_id = null;
      this.devoir.due_date = null;
      this.devoir.description = "";
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
